import eventBus from '@/services/eventBus'
import { useState, useEffect } from 'react'
import { IAlert } from './alertTile.types'

const useAlertService = () => {
  const [active, setActive] = useState(false)
  const [alertData, setAlertData] = useState<IAlert>()

  useEffect(() => {
    const unsubscribe = eventBus.sub('alert.request', (ev) => {
      setAlertData({
        type: ev.type,
        title: ev.title,
        description: ev.description,
      })
      setActive(true)
      setTimeout(() => setActive(false), 15000)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return { alertData, active, setActive }
}

export default useAlertService
